import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content", "toggle"]

    static values = {
        moreText: String,
        lessText: String,
        truncateAt: Number
    }

    connect() {
        this.originalText = this.contentTarget.innerText.trim()
        this.expanded = false

        if (this.originalText.length <= this.truncateAtValue) {
            this.toggleTarget.classList.add("hidden")
            return
        }

        this.truncate()
    }

    toggle(event) {
        event.preventDefault()

        this.expanded ? this.truncate() : this.expand()
        this.expanded = !this.expanded
    }

    truncate() {
        this.contentTarget.innerText =
            this.originalText.slice(0, this.truncateAtValue) + "…"
        this.toggleTarget.innerText = this.moreTextValue
    }

    expand() {
        this.contentTarget.innerText = this.originalText
        this.toggleTarget.innerText = this.lessTextValue
    }
}
